import {RequestInfo} from "@khan/shared-core";

// When logging into our trace store, Langfuse, the user is immediately
// placed into a project. For example:
// https://us.cloud.langfuse.com/project/clusgns9n0000jmtmyllo3jgl
// We currently have 2 projects, one for localhost and one for production
// traces.
const langfuseProject = RequestInfo.IS_DEV_SERVER
    ? "clu04n79700007a2l5dmh6qs5" // Localhost.
    : "clusgns9n0000jmtmyllo3jgl"; // Production.

export function langfuseSessionURL(threadId: string) {
    return `https://us.cloud.langfuse.com/project/${langfuseProject}/sessions/${threadId}`;
}

export function langfuseTraceURL(interactionTraceID: string) {
    return `https://us.cloud.langfuse.com/project/${langfuseProject}/traces/${interactionTraceID}`;
}

export function bigqueryTraceURL(interactionTraceID: string) {
    // @TODO: Link to the query that shows the trace.
    return `https://khanacademy.atlassian.net/wiki/spaces/ENG/pages/3285680162/AI+Trace+-+Big+Query+Analytics+Getting+Started`;
}
